(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxGroupUsers(
    GroupListService, UserListPaging, $rootScope, toastr, $filter, $log, IdpProviderService, GROUP_PROVIDER_TO_IDP_TYPE
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        group: '=group',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        taskId: '&taskId',
        callback: '&callback'
      },
      templateUrl: 'app/components/groupProperties/groupUsers/groupUsers.template.html',
      link: function(scope) {

        scope.usersPaging = new UserListPaging();
        scope.usersList = null;
        scope.usersPage = null;
        scope.usersContainer = null;
        scope.noDataMessage = 'NoSearchResultUser';
        scope.syncIsOngoing = false;

        function resolveParentDirectoryState(group, tenant) {
          if (!group || !group.info || !tenant) {
            return 'UNKNOWN';
          }
          const provider = group.info.provider;
          const mappedType = GROUP_PROVIDER_TO_IDP_TYPE[provider] || (provider && provider.toLowerCase());
          if (!mappedType) {
            $log.warn('groupUsers: could not map group.info.provider to IdP type', provider);
            return 'UNKNOWN';
          }
          const directories = IdpProviderService.directoriesFor(tenant, mappedType);
          const match = directories.find(function (d) {
            return !d.unConnected && d.info && d.info.idp_tenant_identifier === group.info.directoryId;
          });
          if (!match) {
            $log.warn('groupUsers: no directory matched group.info.directoryId', group.info.directoryId);
            return 'UNKNOWN';
          }
          return IdpProviderService.groupSyncStateOf(match.info);
        }

        scope.parentDirectoryState = resolveParentDirectoryState(scope.group, scope.tenant);

        (function() {
          getGroupUsers();
          setListeners();
        })();

        function getGroupUsers() {
          var url = scope.group.info._links['px:users'].href;
          scope.usersPaging.pagingCriteria.groups = scope.group.customProperties.id;
          GroupListService.getGroupUsers(url, scope.usersPaging).then(function(response) {
            scope.usersContainer = response;
            scope.usersList = response.list;
            scope.usersPage = response.page;
          }).catch(function(error) {});
        }

        scope.getNextUserPage = function(showPrevious) {
          if (showPrevious) {
            if (scope.usersPaging.pagingCriteria.page > 0) {
              scope.usersPaging.pagingCriteria.page--;
            }
          } else {
            if (scope.usersPaging.pagingCriteria.page + 1 < scope.usersPage.totalPages) {
              scope.usersPaging.pagingCriteria.page++;
            }
          }
          getGroupUsers();
        }

        scope.syncGroupMembers = function () {
          scope.syncIsOngoing = true;
          scope.group.syncGroupMembers().then(function(response) {
            toastr.success($filter('translate')('GroupSynchronization'))
            scope.taskId({data: response.data});
          }).catch(function(error) {
            toastr.error($filter('translate')('GroupSyncNotVerified'))
          });
        }

        function setListeners () {
        //   $rootScope.$on('GROUP_SYNC_COMPLETE', function (name, data) {
        //     if (data.group.info._links.self.href === scope.group.info._links.self.href) {
        //       scope.syncIsOngoing = false;
        //     }
        //   })
        }

        var GROUP_SYNC_COMPLETE_listener = $rootScope.$on('GROUP_SYNC_COMPLETE', function (name, data) {
          if (data.group.info._links.self.href === scope.group.info._links.self.href) {
            scope.syncIsOngoing = false;
          }
        })

        scope.$on('$destroy', function() {
          GROUP_SYNC_COMPLETE_listener();
        });

      }
    };
  }

  pxGroupUsers.$inject = ['GroupListService', 'UserListPaging','$rootScope', 'toastr', '$filter', '$log', 'IdpProviderService', 'GROUP_PROVIDER_TO_IDP_TYPE'];

  angular
    .module('printix-admin')
    .directive('pxGroupUsers', pxGroupUsers);

})();
